let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ix4i0")).then(() => parcelRequire('5D7du'));